// Ro magerdropdown name wise fill data

import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { Button, Card, Col, Row } from "react-bootstrap";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, Link } from "react-router-dom";
import swal from "sweetalert";
import Select from "react-select"
import {
  createRO,
  updateRO,
  getRoManagerDropDown,
} from "../../../Service/AllRoOnboardingAPI";
import { getListOfUserById } from "../../../Service/AllAccessGetById";

import {

  getDispenserSrNoList,
  getServiceEngineerList,
} from "../../master/AllUserDropDown";

import {
  getDispenserDropDownListForCalibration,

} from "../../../Service/AllWorkOrderCalibrationAPI";



import {
  getDispenserDropDownListForFieldJob,

} from "../../../Service/AllWorkOrderFieldIssueAPI";

import {
  getDispatchListByDispenserSrNo,

} from "../../../Service/AllWorkOrder";

const compressImageToBase64 = (file, maxSizeKB = 100) => {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let width = img.width;
        let height = img.height;

        const maxDimension = 800;
        if (width > height) {
          if (width > maxDimension) {
            height = Math.round((height * maxDimension) / width);
            width = maxDimension;
          }
        } else {
          if (height > maxDimension) {
            width = Math.round((width * maxDimension) / height);
            height = maxDimension;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        let quality = 0.8;
        let base64 = canvas.toDataURL("image/jpeg", quality);

        while (base64.length / 1024 > maxSizeKB && quality > 0.1) {
          quality -= 0.05;
          base64 = canvas.toDataURL("image/jpeg", quality);
        }

        resolve(base64);
      };
    };

    reader.readAsDataURL(file);
  });
};


const statusOptions = ["VALIDATED", "PENDING", "INCOMPLETE"];
export const selectSitetype = [
  { value: "COCO", label: "Customer Owned Customer Operated (COCO)", },
  { value: "CODO", label: "Customer Owned Dealer Operated (CODO)", },
  { value: "DODO", label: "Dealer Owned Dealer Operated (DODO)", },
  { value: "Private", label: "Private", },
];
const customerOptions = ["IOCL", "BPCL", "HPCL", "MRPL", "JioBP", "Nayara"];
const roStatusOptions = [
  "Activated",
  "Deactivated",
  "Under_Commissioning",
  "Under_Installation",
  "Stamping_or_Calibration",
];





const getValidationSchema = (isEditMode) =>
  Yup.object().shape({
    roName: Yup.string()
      .trim()
      .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
      .required("RO name is required"),

    roCode: Yup.string()
      .trim()
      .required("RO Code is required"),

    roAlternativeContactPerson: Yup.string()
      .trim()
      .matches(/^[A-Za-z\s]+$/, "Enter only alphabets"),

    serviceEngineer: Yup.object().shape({
      seId: Yup.string()
        .required("Service Engineer is required"),
      seName: Yup.string()
        .required("Service Engineer name is required"),
    }),

    address: Yup.string()
      .trim()
      .required("RO Address is required"),


    roRemark: Yup.string()
      .trim()
      .when([], {
        is: () => isEditMode,
        then: (schema) =>
          schema.required("RO Remark is required "),
        otherwise: (schema) => schema.notRequired(),
      }),

    city: Yup.string()
      .trim()
      .required("RO City is required"),

    state: Yup.string()
      .trim()
      .required("RO State is required"),

    country: Yup.string()
      .trim()
      .required("RO Country is required"),

    pincode: Yup.string()
      .matches(/^[0-9]{6}$/, "Invalid pincode")
      .required("Pincode is required"),

    roEmail: Yup.string()
      .email("Invalid RO email format")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Invalid RO Email Format"
      )
      .required("RO email is required"),

    roAlternativeEmail: Yup.string()
      .nullable()
      .notRequired()
      .email("Invalid Alternative email format")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Invalid Alternative Email Format"
      ),

    roContact: Yup.string()
      .matches(/^[7-9][0-9]{9}$/, "Invalid RO contact number")
      .required("RO Contact Number is required"),

    roAlternativeContact: Yup.string()
      .nullable()
      .notRequired()
      .matches(
        /^[7-9][0-9]{9}$/,
        "Invalid alternate RO contact number"
      ),

    contactPerson: Yup.string()
      .trim()
      .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
      .required("Contact Person Name is required"),

    roSiteType: Yup.string()
      .required("ro siteType is required"),

    customerName: Yup.string()
      .required("Customer name is required"),

    roStatus: Yup.string()
      .required("RO status is required"),

    dispensers: Yup.array()
      .of(
        Yup.object().shape({
          dispenserNumber: Yup.string()
            .trim()
            .required("Dispenser Serial Number is required"),
        })
      )
      .min(1, "At least one dispenser is required"),
  });



export default function ROEntryForm() {
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [loadingPin, setLoadingPin] = useState(false);
  const [pincode, setPincode] = useState("");
  const [selectedServiceEngineer, setSelectedServiceEngineer] = useState("");
  const [userMblNo, setUserMblNo] = useState("");
  const [serviceEngineerName, setServiceEngineerName] = useState([]);


  const [mergedDispenserOptions, setMergedDispenserOptions] = useState([]);
  const [userEmailId, setUserEmailId] = useState("");
  const formikRef = React.useRef(null);
  const [roManagerList, setRoManagerList] = useState([]);



  const location = useLocation();
  const editData = location.state?.roData;
  const isEditMode = Boolean(editData);



  useEffect(() => {
    fetchRoManagers();
  }, []);

  const fetchRoManagers = async () => {
    try {
      const res = await getRoManagerDropDown();
      const raw = res?.data || [];

      // Convert into Select options
      const formatted = raw.map((item) => ({
        value: item.pkUserId,
        label: item.userName,
        fullData: item      // Store full data for autofill
      }));

      setRoManagerList(formatted);
    } catch (err) {
      console.log("RO Manager fetch error", err);
    }
  };
  useEffect(() => {
    getServiceEngineersList();
  }, [])


  const fetchAddressByPincode = async (pin, formik) => {
    if (pin.length !== 6) return;

    setLoadingPin(true);

    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
      const data = await res.json();

      if (data[0].Status === "Success") {
        const postOffices = data[0].PostOffice;

        const detectedState = postOffices[0].State;
        const detectedDistrict = postOffices[0].District;
        const detectedCountry = "India";

        // UI state
        setCountry(detectedCountry);
        setState(detectedState);
        setDistrict(detectedDistrict)


        formik.setFieldValue("country", detectedCountry);
        formik.setFieldValue("state", detectedState);
        formik.setFieldValue("district", detectedDistrict);
        formik.setFieldValue("pincode", pin);

        const cities = postOffices.map(po => ({
          label: po.Name,
          value: po.Name
        }));

        setCityOptions(cities);
        formik.setFieldValue("city", cities[0]?.value || "");
      } else {
        setState("");
        setCityOptions([]);
        formik.setFieldValue("city", "");
        swal("Invalid PIN", "No data found for this pincode", "warning");
      }
    } catch (err) {
      swal("Error", "Failed to fetch pincode data", "error");
    } finally {
      setLoadingPin(false);
    }
  };


  const handleFileChange = async (event, setFieldValue, fieldName) => {
    const file = event.target.files[0];
    if (file) {
      const compressedBase64 = await compressImageToBase64(file, 100);
      setFieldValue(fieldName, compressedBase64);
    }
  };



  const autoFillDispenserConfig = async (srNo, formik, index) => {
    try {
      const result = await getDispatchListByDispenserSrNo(srNo);

      if (!result?.data?.[0]) {
        swal("Info", "No dispenser config found", "info");
        // Clear the fields if SR number has no data
        formik.setFieldValue(`dispensers.${index}.dispenserConfig`, "");
        return;
      }

      const dispatch = result.data[0];

      // Always update dispenserConfig
      formik.setFieldValue(
        `dispensers.${index}.dispenserConfig`,
        dispatch.modelname ?? dispatch.modelName ?? "",
        true
      );

      // Only update bayNumber if empty
      if (!formik.values.dispensers[index].bayNumber) {
        formik.setFieldValue(
          `dispensers.${index}.bayNumber`,
          dispatch.bayNumber || "",
          true
        );
      }

    } catch (error) {
      console.error("Dispatch fetch failed", error);
      swal("Error", "Failed to fetch dispenser configuration", "error");
    }
  };



  useEffect(() => {
    fetchInstallationDispensers();
    fetchCalibrationDispensers();
    fetchFieldJobDispensers();
  }, []);

  useEffect(() => {
    const fetchAndMergeDispensers = async () => {
      const installation = await fetchInstallationDispensers();
      const calibration = await fetchCalibrationDispensers();
      const fieldJob = await fetchFieldJobDispensers();


      const merged = [...installation, ...calibration, ...fieldJob];


      const unique = [...new Set(merged)];


      const sortedDesc = unique.sort((a, b) => b.localeCompare(a));


      const dropdownOptions = sortedDesc.map((d) => ({
        value: d,
        label: d,
      }));

      setMergedDispenserOptions(dropdownOptions);
    };

    fetchAndMergeDispensers();
  }, []);






  const fetchInstallationDispensers = async () => {
    try {
      const result = await getDispenserSrNoList();

      return result.map((item) =>
        typeof item === "object" ? item.value || item.label : item
      );
    } catch (err) {
      console.error("Installation dispenser fetch failed", err);
      return [];
    }
  };


  const fetchCalibrationDispensers = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const result = await getDispenserDropDownListForCalibration(headers);

      return result?.data?.length ? result.data : [];
    } catch (err) {
      console.error("Calibration dispenser fetch failed", err);
      return [];
    }
  };

  const handleRoManagerSelect = (selected, formik) => {
    if (!selected) return;

    const d = selected.fullData; // full object from API

    formik.setFieldValue("pkUserId", selected.value);
    formik.setFieldValue("contactPerson", d.userName || "");
    formik.setFieldValue("roEmail", d.email || "");
    formik.setFieldValue("roContact", d.mobileNo || "");

    // Auto-fill address fields if backend provides
   formik.setFieldValue("city", d.city || "");
  formik.setFieldValue("district", d.district || "");
  formik.setFieldValue("state", d.state || "");
  formik.setFieldValue("country", d.country || "India");

  // Pincode
  if (d.pincode) {
    formik.setFieldValue("pincode", d.pincode);
  }

  // Update UI States also (optional)
  setDistrict(d.district || "");
  setState(d.state || "");
  setCountry(d.country || "India");

  // When city comes from backend
  if (d.city) {
    setCityOptions([{ label: d.city, value: d.city }]);
  }
};

  const fetchFieldJobDispensers = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      const result = await getDispenserDropDownListForFieldJob(headers);

      return result?.data?.length ? result.data : [];
    } catch (error) {
      console.log("Field Job fetch error", error);
      return [];
    }
  };

  // Function declaration of get Service Engineers list
  const getServiceEngineersList = async () => {
    await getServiceEngineerList().then((result) => {
      setServiceEngineerName(result);
    });
  };


  useEffect(() => {
    if (isEditMode && formikRef.current && editData?.dispensers?.length) {
      editData.dispensers.forEach((disp, index) => {
        if (disp.dispenserNumber) {
          autoFillDispenserConfig(disp.dispenserNumber, formikRef.current, index);
        }
      });
    }
  }, [isEditMode, editData]);




  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        pkUserId: null,
        roName: editData?.roName || "",
        roCode: editData?.roCode || "",
        address: editData?.address || "",
        district: editData?.district || "",
        roRemark: editData?.roRemark || "",
        city: editData?.city || "",
        state: editData?.state || "",
        pincode: editData?.pincode || "",
        country: editData?.country || "India",
        roEmail: editData?.roEmail || "",
        roAlternativeEmail: editData?.roAlternativeEmail || "",
        roContact: editData?.roContact || "",
        roAlternativeContact: editData?.roAlternativeContact || "",
        contactPerson: editData?.contactPerson || "",
        roAlternativeContactPerson:
          editData?.roAlternativeContactPerson || "",
        latitude: editData?.latitude || "",
        longitude: editData?.longitude || "",
        incorporationCertificate: editData?.incorporationCertificate || "",
        gstCertificate: editData?.gstCertificate || "",
        panCard: editData?.panCard || "",
        contactAadhar: editData?.contactAadhar || "",
        alternativeContactAadhar: editData?.alternativeContactAadhar || "",
        status: "PENDING" || "",
        roSiteType: editData?.roSiteType || "",
        customerName: editData?.customerName || "",
        roStatus: editData?.roStatus || "",
        serviceEngineer: {
          seId: editData?.serviceEngineer?.seId || "",
          seName: editData?.serviceEngineer?.seName || "",
          seEmail: editData?.serviceEngineer?.seEmail || "",
          seContactNumber: editData?.serviceEngineer?.seContactNumber || "",
        },

        dispensers: editData?.dispensers?.length
          ? editData.dispensers.map(d => ({
            dispenserConfig: d.modelName || d.modelname || "",
            dispenserNumber: d.dispenserNumber || "",
            bayNumber: d.bayNumber || "",
            dispenserId: d.dispenserId || null,
          }))
          : [{ dispenserConfig: "", dispenserNumber: "", bayNumber: "" }],

      }}
      // validationSchema={validationSchema}
      validationSchema={getValidationSchema(isEditMode)}


      onSubmit={(values, { resetForm }) => {
        const payload = {
          ...values,
          ...(isEditMode
            ? { updatedBy: sessionStorage.getItem("userName") }
            : { createdBy: sessionStorage.getItem("userName") }),
        };

        const apiCall = isEditMode
          ? updateRO(editData.roId, payload)
          : createRO(payload);

        apiCall
          .then(() => {
            swal(
              "Success",
              isEditMode
                ? "RO updated successfully!"
                : "RO created successfully!",
              "success"
            );

            setTimeout(() => {
              resetForm();
              window.location.href = "/Callcenter/RoGetlist";
            }, 2000);
          })
          .catch((err) => {
            swal("Error", "Failed", "error");
            console.error(err);
          });
      }}

    >

      {(formik) => (

        <>

          <div className="d-flex m-3">
            <Link to="RoGetlist" className="fieldLink btn btn-primary">
              <FontAwesomeIcon icon={faAngleLeft} className="me-2" />
              Back
            </Link>
          </div>

          <Card className="bg-white shadow-sm mb-4">
            <Card.Body>
              <h5 className="head mb-4 text-center">
                {isEditMode ? "Update Retail Outlet" : "Retail Outlet Entry Form"}
              </h5>

              <Form>
                <Row>

                  <Col md={6} className="mb-3">
                    <label className="LabelNew">RO Name *</label>
                    <Field type="text" className="form-control" name="roName" autoComplete="off" placeholder="Enter ro name" disabled={isEditMode} />
                    <ErrorMessage
                      name="roName"
                      className="text-danger"
                      component="div"
                    />
                  </Col>
                  <Col md={6} className="mb-3">
                    <label className="LabelNew">RO Code *</label>
                    <Field type="text" className="form-control" name="roCode" autoComplete="off" placeholder="Enter ro code" disabled={isEditMode} />
                    <ErrorMessage
                      name="roCode"
                      className="text-danger"
                      component="div"
                    />
                  </Col>

                  {/* <Col md={6} className="mb-3">
                    <label className="LabelNew">RO Manager Name *</label>
                    <Field type="text" className="form-control" name="contactPerson" autoComplete="off" placeholder="Enter ro manager name" />
                    <ErrorMessage
                      name="contactPerson"
                      className="text-danger"
                      component="div"
                    />
                  </Col> */}

              

                  <Col md={6} className="mb-3">
                    <label className="LabelNew">RO Manager Name *</label>

                    <Select
                      options={roManagerList}
                      placeholder="Select RO Manager"
                      value={roManagerList.find(
                        (item) => item.value === formik.values.pkUserId
                      )}
                      onChange={(selected) => handleRoManagerSelect(selected, formik)}
                    />

                    <ErrorMessage
                      name="roManagerId"
                      component="div"
                      className="text-danger"
                    />
                  </Col>
                  
                      {/* CONTACT DETAILS */}
                  <Col md={6} className="mb-3">
                    <label className="LabelNew">RO Manager Email *</label>
                    <Field type="email" className="form-control" name="roEmail" autoComplete="off" placeholder="Enter ro manager email" disabled={isEditMode} />
                    <ErrorMessage
                      name="roEmail"
                      className="text-danger"
                      component="div"
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <label className="LabelNew">RO Manager Contact Number *</label>
                    <Field
                      type="text"
                      className="form-control"
                      name="roContact"
                      maxLength="10"
                      autoComplete="off"
                      placeholder="Enter ro manager contact number"
                    />
                    <ErrorMessage
                      name="roContact"
                      className="text-danger"
                      component="div"
                    />
                  </Col>



                  <Col md={6} className="mb-3">
                    <label>RO Alternative Manager Name</label>
                    <Field
                      type="text"
                      className="form-control"
                      name="roAlternativeContactPerson"
                      autoComplete="off"
                      placeholder="Enter ro alternative manager name"
                    />
                    <ErrorMessage
                      name="roAlternativeContactPerson"
                      className="text-danger"
                      component="div"
                    />
                  </Col>


                  {/* <Col md={6} className="mb-3">
                    <label>RO Alternative Email</label>
                    <Field
                      type="email"
                      className="form-control"
                      name="roAlternativeEmail"
                      autoComplete="off"
                      placeholder="Enter ro alternative email"
                    />
                     <ErrorMessage
                      name="roAlternativeEmail"
                      className="text-danger"
                      component="div"
                    />
                  </Col> */}


                  <Col md={6} className="mb-3">
                    <label>RO Alternative Manager Contact Number</label>
                    <Field
                      type="text"
                      className="form-control"
                      name="roAlternativeContact"
                      maxLength="10"
                      autoComplete="off"
                      placeholder="Enter ro alternative manager contact number"
                    />
                    <ErrorMessage
                      name="roAlternativeContact"
                      className="text-danger"
                      component="div"
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <div className="form-group">
                      <label className="LabelNew mb-1">
                        {" "}
                        Service Engineer Name *{" "}
                      </label>
                      <Select
                        placeholder="Select service engineer name"
                        options={serviceEngineerName}
                        onChange={async (e) => {
                          const token = sessionStorage.getItem("token");
                          const headers = { Authorization: `Bearer ${token}` };

                          const result = await getListOfUserById(e.id, headers);


                          setSelectedServiceEngineer(e.id);
                          setUserMblNo(result.data.mobileNo);
                          setUserEmailId(result.data.email);


                          formik.setFieldValue("serviceEngineer.seId", e.id);
                          formik.setFieldValue("serviceEngineer.seName", e.label || e.value);
                          formik.setFieldValue("serviceEngineer.seEmail", result.data.email);
                          formik.setFieldValue(
                            "serviceEngineer.seContactNumber",
                            result.data.mobileNo
                          );
                        }}

                      />
                    </div>
                    <ErrorMessage
                      name="serviceEngineer"
                      className="text-danger"
                      component="div"
                    />
                  </Col>


                  <Col md={6} className="mb-3">

                    <label className="Label mb-1">
                      {" "}
                      Service Engineer Mobile No
                    </label>
                    <Field
                      type="text"
                      placeholder="Service engineer mobile no."
                      className="form-control"
                      name="serviceEngineer.seContactNumber"
                      readOnly
                    />
                  </Col>
                  {/* <Col md={6} className="mb-3">
                    <label className="Label mb-1">
                      Service Engineer Email
                    </label>
                    <Field
                      type="email"
                      className="form-control"
                      name="serviceEngineer.seEmail"
                      readOnly
                    />
                  </Col> */}


                  <Col md={6} className="mb-3">
                    <div className="form-group">
                      <label className="LabelNew">RO Pincode * </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="pincode"
                        maxLength="6"
                        autoComplete="off"
                        placeholder="Enter pincode"
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) e.preventDefault();
                        }}
                        onChange={(e) => {
                          formik.handleChange(e);
                          setPincode(e.target.value);
                          fetchAddressByPincode(e.target.value, formik);
                        }}

                      />

                    </div>
                    <ErrorMessage
                      name="pincode"
                      className="text-danger"
                      component="div"
                    />
                  </Col>


                  <Col md={6} className="mb-3">
                    <div className="form-group">
                      <label className="LabelNew">RO Country * </label>
                      <div className="example-wrapper">


                        <input
                          className="form-control"
                          value={formik.values.country}
                          readOnly
                        />

                      </div>
                    </div>
                  </Col>

                  <Col md={6} className="mb-3">
                    <div className="form-group">
                      <label className="LabelNew">Ro State * </label>
                      <div className="example-wrapper">



                        <input
                          className="form-control"
                          value={formik.values.state}
                          readOnly
                        />

                      </div>
                    </div>
                  </Col>




                </Row>
                <Row>
                  <Col md={6} className="mb-3">
                    <div className="form-group">
                      <label className="LabelNew">District * </label>
                      <div className="example-wrapper">



                        <input
                          className="form-control"
                          value={formik.values.district}
                          readOnly
                        />

                      </div>
                    </div>
                  </Col>


                  <Col md={6} className="mb-3">
                    <label className="LabelNew">RO City *</label>
                    <Select
                      placeholder={loadingPin ? "Loading..." : "Select City"}
                      options={cityOptions}
                      isDisabled={!cityOptions.length}
                      value={cityOptions.find(c => c.value === formik.values.city) || null}
                      onChange={(e) => formik.setFieldValue("city", e.value)}
                    />

                  </Col>

                  {/* 
                  <Col md={6} className="mb-3">
                    <label className="LabelNew" >RO Address *</label>
                    <Field type="text" className="form-control" name="address" autoComplete="off" placeholder="Enter ro address" />
                   <ErrorMessage
                      name="address"
                      className="text-danger"
                      component="div"
                    />
                  </Col> */}


                  <Col md={6} className="mb-3">
                    <label className="LabelNew">
                      RO Address *
                      <Button
                        variant="link"
                        style={{ padding: 0, marginLeft: "8px", fontSize: "13px", color: "blue" }}
                        onClick={() => window.open("https://www.google.com/maps", "_blank")}
                      >
                        📍 Click here to open map
                      </Button>
                    </label>

                    <Field
                      type="text"
                      name="address"
                      className="form-control"

                      placeholder="Enter RO site full address"
                      autoComplete="off"
                    />

                    <ErrorMessage
                      name="address"
                      component="div"
                      className="text-danger"
                    />

                    <small className="text-muted">
                      Use map to search RO site address and paste here
                    </small>
                  </Col>




                  {/* GEO */}
                  {/* <Col md={6} className="mb-3">
                    <label>Latitude</label>
                    <Field type="number" className="form-control" name="latitude"  autoComplete="off" placeholder="Enter lattitude"/>
                  </Col>

                  <Col md={6} className="mb-3">
                    <label>Longitude</label>
                    <Field type="number" className="form-control" name="longitude"  autoComplete="off" placeholder="Enter longitude"/>
                  </Col> */}

                  {/* DROPDOWNS */}

                  {/* <Col md={6} className="mb-3">
                    <label className="LabelNew">Status *</label>
                    <Field as="select" className="form-control" name="status">
                      <option value="">Select Status</option>
                      {statusOptions.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="status"
                      className="text-danger"
                      component="div"
                    />
                  </Col> */}


                  <Col md={6} className="mb-3">
                    <div className="form-group">
                      <label className="LabelNew mb-1">Site Type *</label>

                      <Select
                        name="roSiteType"
                        placeholder="Select Site Type"
                        options={selectSitetype}
                        value={
                          selectSitetype.find(
                            (opt) => opt.value === formik.values.roSiteType
                          ) || null
                        }
                        onChange={(selected) => {
                          formik.setFieldValue("roSiteType", selected.value);
                        }}
                      />

                      <ErrorMessage
                        name="roSiteType"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </Col>


                  <Col md={6} className="mb-3">
                    <label className="LabelNew">Customer Name *</label>
                    <Field as="select" className="form-control" name="customerName" autoComplete="off">
                      <option value="">Please Select Customer</option>
                      {customerOptions.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="customerName"
                      className="text-danger"
                      component="div"
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <label className="LabelNew">RO Status *</label>
                    <Field as="select" className="form-control" name="roStatus" autoComplete="off" >
                      <option value="">Please Select RO Status</option>
                      {roStatusOptions.map((r) => (
                        <option key={r} value={r}>
                          {r}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="roStatus"
                      className="text-danger"
                      component="div"
                    />
                  </Col>


                  {[
                    { label: "Incorporation Certificate Image ", name: "incorporationCertificate" },
                    { label: "GST Certificate Image", name: "gstCertificate" },
                    { label: "PAN Card Image", name: "panCard" },
                    { label: "Aadhaar Card Image", name: "contactAadhar" },
                    // { label: "Alternative Contact Aadhaar Image", name: "alternativeContactAadhar" },
                  ].map((field) => (
                    <Col md={6} className="mb-3" key={field.name}>
                      <label>{field.label}</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={(e) =>
                          handleFileChange(e, formik.setFieldValue, field.name)
                        }
                      />

                      {formik.values[field.name] && (
                        <img
                          src={formik.values[field.name]}
                          alt={field.label}
                          className="mt-2 border rounded"
                          style={{
                            width: "140px",
                            height: "140px",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </Col>
                  ))}

                  {isEditMode && (
                    <Col md={6} className="mb-3">
                      <label className="LabelNew">RO Remark *</label>
                      <Field type="text" className="form-control" name="roRemark" autoComplete="off" placeholder="Please enter reason to update" />
                      <ErrorMessage
                        name="roRemark"
                        className="text-danger"
                        component="div"
                      />
                    </Col>
                  )}

                  <Col md={12} className="mb-3">
                    <FieldArray name="dispensers">
                      {(arrayHelpers) => (
                        <>
                          {formik.values.dispensers.map((disp, index) => (
                            <Row key={index} className="mb-2">

                              <Col md={4}>
                                <h6 className="LabelNew">Dispenser SR Number *</h6>


                                <Select
                                  options={mergedDispenserOptions}
                                  placeholder="Select Dispenser SR No"
                                  value={
                                    mergedDispenserOptions.find(
                                      (opt) => opt.value === disp.dispenserNumber
                                    ) || null
                                  }
                                  onChange={(selected) => {
                                    if (!selected) {
                                      formik.setFieldValue(`dispensers.${index}.dispenserNumber`, "");
                                      formik.setFieldValue(`dispensers.${index}.dispenserConfig`, "");
                                      formik.setFieldValue(`dispensers.${index}.bayNumber`, "");
                                      return;
                                    }

                                    const srNo = selected.value;

                                    formik.setFieldValue(
                                      `dispensers.${index}.dispenserNumber`,
                                      srNo
                                    );


                                    autoFillDispenserConfig(srNo, formik, index);
                                  }}
                                />



                              </Col>

                              <Col md={4}>
                                <h6>Dispenser Config Name</h6>
                                <Field
                                  type="text"
                                  name={`dispensers.${index}.dispenserConfig`}
                                  className="form-control"
                                  readOnly
                                  placeholder="Dispenser Config "
                                />
                              </Col>



                              <Col md={3}>
                                <h6>Bay Number</h6>
                                <Field
                                  type="text"
                                  name={`dispensers.${index}.bayNumber`}
                                  className="form-control"
                                  placeholder="Enter Bay Number"
                                  autoComplete="off"
                                />
                              </Col>

                              <Col md={1} className="text-end">
                                {/* <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  X
                                </Button> */}
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => {
                                    arrayHelpers.remove(index);
                                    formik.setFieldValue(
                                      "dispensers",
                                      formik.values.dispensers.filter((_, i) => i !== index),
                                      true
                                    );
                                  }}
                                >
                                  X
                                </Button>

                              </Col>
                            </Row>
                          ))}

                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={() =>
                              arrayHelpers.push({
                                dispenserConfig: "",
                                dispenserNumber: "",
                                bayNumber: "",
                              })

                            }
                          >
                            + Add Dispensers
                          </Button>
                        </>
                      )}
                    </FieldArray>
                  </Col>
                </Row>



                <div className="text-center mt-3">
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={!(formik.isValid && formik.dirty)}
                  >
                    {isEditMode ? "Update RO" : "Create RO"}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </>
      )}
    </Formik>
  );
}

